import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const VibratingPhone = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size), ...props.style }}
    viewBox="0 0 112 122"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M21.624 52.911a2.708 2.708 0 011.402 5.232c-8.655 2.32-13.81 11.247-11.49 19.902a2.708 2.708 0 01-5.232 1.402c-3.093-11.54 3.78-23.444 15.32-26.536zM59.376 110.089a2.708 2.708 0 01-1.402-5.232c8.655-2.32 13.81-11.247 11.49-19.902a2.708 2.708 0 015.232-1.402c3.093 11.54-3.78 23.444-15.32 26.536z"
        fill="#BEBEBE"
      />
      <path
        d="M44.73 112.089a5.417 5.417 0 01-7.398 1.982L13.877 100.53a5.417 5.417 0 01-1.983-7.4l24.375-42.218a5.417 5.417 0 017.4-1.983L67.122 62.47a5.417 5.417 0 011.983 7.4l-24.375 42.219z"
        fill="#505050"
      />
      <path
        fill="#62CC1E"
        d="M61.707 71.852L38.25 58.311 19.293 91.148l23.455 13.541z"
      />
      <g fill="#1EA6D1">
        <path
          d="M91.75.953h-13.5C67.066.953 58 10.02 58 21.203c0 9.635 6.735 17.683 15.75 19.731v14.02l15.75-13.5h2.25c11.184 0 20.25-9.067 20.25-20.25 0-11.185-9.066-20.25-20.25-20.25z"
          fillOpacity={0.4}
        />
        <path d="M87.25 27.953h-13.5a2.256 2.256 0 01-2.25-2.25 2.256 2.256 0 012.25-2.25h13.5a2.256 2.256 0 012.25 2.25 2.256 2.256 0 01-2.25 2.25zM96.25 18.953h-22.5a2.256 2.256 0 01-2.25-2.25 2.256 2.256 0 012.25-2.25h22.5a2.256 2.256 0 012.25 2.25 2.256 2.256 0 01-2.25 2.25z" />
      </g>
    </g>
  </svg>
);
